import { AssetType } from 'core/logic/asset/asset.types'
import { UserAddress } from 'core/modules/firebase/service/user'

export enum PREDEFINED_DEADLINES {
  A_MONTH = 'one_month',
  TWO_MONTHS = 'two_months',
  THREE_MONTHS = 'three_months',
}
export type OfferForm = {
  selectedQuantity: number
  tokenId?: AssetType['tokenId']
  cid?: string
  amount: {
    [k: CryptoCurrencySymbol]: { checked: boolean; amount: number } | undefined
  }
  selectedDeadline: PREDEFINED_DEADLINES
  asset: Pick<AssetType, 'galleryId' | 'tokenId' | 'id'>
  description: string
  address?: UserAddress
  paymentData?: string
}
export enum CreateOfferFormMode {
  CREATION,
  EDITION,
}
